import Logo from "../images/Logo.png";
export const Footer = () => {
  return (
    <>
      <footer className="p-6 bg-transparent border-t"></footer>
    </>
  );
};
